import { ProductCatalog } from "@/api/models/shop/ProductCatalog";
import { useCatalogService } from "../../../cbi-generator/frontend/composables/useCatalogFrontendService";
import { useEnv } from "../useEnv";
import client from "@/api/client";
import { CatalogApiClient } from "../../../cbi-generator/frontend/api/CatalogApiClient";
import { CatalogFrontendService } from "../../../cbi-generator/frontend/services/CatalogFrontendService";

let catalog: ProductCatalog | null = null;
let loading: Promise<ProductCatalog> | null = null;

async function loadCatalog() {
  return new ProductCatalog(
    useEnv().mode == "STAFF"
      ? await useCatalogService().onSaleItemInstancesStaff()
      : await new CatalogFrontendService(
          new CatalogApiClient(client),
        ).browseItemsPublic(),
  );
}

export const useCatalog = async () => {
  if (catalog) return catalog;
  loading ??= loadCatalog().finally(() => {
    loading = null;
  });
  catalog = await loading;
  return catalog;
};

export const useCatalogDeferred = () => {
  const catalogDeferred = ref<ProductCatalog | null>(catalog);
  useCatalog().then((a) => {
    catalogDeferred.value = a;
  });
  return catalogDeferred;
};
